import { Transfer } from '@formily/antd';
import { createSchemaComponent } from '../../shared';
export default createSchemaComponent({
    componentName: 'Transfer',
    component: Transfer,
});
